<template>
  <v-menu bottom right offset-y origin="top left" transition="scale-transition">
    <template v-slot:activator="{ attrs, on }">
      <v-btn icon v-bind="attrs" v-on="on">
        <!-- <v-badge color="red" overlap>
          <template v-slot:badge>
            <span>{{ items.length }}</span>
          </template>

          <v-icon>mdi-download</v-icon>
        </v-badge> -->
        <v-icon>mdi-download</v-icon>
      </v-btn>
    </template>
    <v-list width="380">
      <v-subheader
        >Delivery extention <v-spacer></v-spacer>
        <v-icon>mdi-download</v-icon></v-subheader
      ><v-divider></v-divider>

      <v-list-item v-for="(item, i) in items" :key="i">
        <v-list-item-avatar class="align-self-center" color="white" contain>
          <v-avatar size="56">
            <v-img src="../../assets/quick.png" max-height="50">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-row> </template
            ></v-img>
          </v-avatar>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
          <v-list-item-subtitle>{{ item.subtitle }} </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn depressed target="_blank" :href="item.link" small>
            open link

            <v-icon color="primary" right> {{ item.icon }} </v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  name: "download",
  data: () => ({
    items: [
      {
        icon: "mdi-open-in-new",
        title: "Delivery employee",
        subtitle: "pexcode app",
        link: "https://pexcode.com/app/",
      },
      // {
      //   icon: "mdi-open-in-new",
      //   title: "notifaction app",
      //   subtitle: "pexcode app",
      //   link: "",
      // },
      // {
      //   icon: "mdi-open-in-new",
      //   title: "Ranerai for windows 7 /8 /10",
      //   subtitle: "mediafire",
      //   link: "",
      // },
    ],
  }),
};
</script>
